export default __webpack_public_path__ + "static/upkeep-logo-color-light-89335d6bb404232b45a4c28767cc5697.svg";